export enum HeaderStep {
	PersonalData = 0,
	AmountRequested = 1,
	Authorization = 2,
}
